/* eslint-disable max-len */
import { VoidCallback } from '@deqo/foundation';
import React, { FC, ReactNode } from 'react';
import { LFC } from '../../Legacy';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { LinkButton } from '../dashboard/elements/LayoutElements';
import { ButtonVariant } from './../../ui';

export const openUpgradeWindow = (accountId: string) => {
    window.open(`/pricing?accountId=${accountId}`, '_blank');
};

export const useUpgradePageOpener = () => {
    const { id } = useResolve(AccountModel);
    return () => openUpgradeWindow(id);
};

export const UpgradeButton: LFC<{ label?: string, variant?: ButtonVariant, onAction?: VoidCallback }> = ({ label, variant, onAction }) => {
    const { id } = useResolve(AccountModel);
    return <LinkButton variant={variant ?? 'primary'} target="_blank" href={`/pricing?accountId=${id}`}>
        {label ?? 'Upgrade'}
    </LinkButton>;
};

export const UpgradeTextButton: FC<{ onAction?: VoidCallback, children?: ReactNode }> = ({ onAction, children }) => {
    const { id } = useResolve(AccountModel);
    return <a target="_blank" href={`/pricing?accountId=${id}`} rel="noreferrer">
        {children}
    </a>;
};
